import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_ASSET_MODEL_SUCCESS,
  FETCH_ASSET_MODEL_SUCCESS,
  GET_ASSET_MODEL_SUCCESS,
  SAVE_ASSET_MODEL_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_MODEL_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_MODEL_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_MODEL_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_MODEL_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetModel } = store.getState();
      const { query } = assetModel;
      const response = await axios.get(`/asset-model?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();
      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item };
        delete data.file;
        documentData.push(data)
      });
      if (payload.files && payload.files.file) {
        formData.append('fileIcon', payload.files.file);
      }
      formData.append('documentData', JSON.stringify(documentData));
      Object.keys(payload).forEach(key => {
        if (key === 'documents' && key === 'files[]') {
          return
        }
        formData.append(key, payload[key]);
      });


      const response = await axios.post(`/asset-model`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      let createdData = null;
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        createdData = response.data;
      }

      if (!redirect) {
        if (subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/asset-model');
        dispatch(getResource());
      }

      return createdData;
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
      return null;
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      if (payload.files && payload.files.file) {
        formData.append('fileIcon', payload.files.file);
      }
      payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item };
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }

        formData.append(key, payload[key]);
      });
      const response = await axios.put(`/asset-model/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/asset-model');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-model/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: { ...response.data, time: new Date().getTime() } }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/common/asset-model/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { subAssembly } = store.getState();
      const { query } = subAssembly;
      const response = await axios.get(`/asset-model/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      // console.log(columns)
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
